var productCardMarkup = `
<ul id="main-collection-product-grid" class="grid">
   {{#products}} 
   <li class="grid__item">
   <div class="swym-wishlist-grid collection-grid">
     <div class="product-item swym-wishlist-item swym-is-anchorc col_slide">
        <div class="snippet-product-grid" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" data-variant-name="{{vi}}">
           <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
             <span class="swym-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
              <path d="M11.1667 1C11.1356 1 11.1051 1 11.074 1.0006C10.084 1.02273 9.11501 1.45041 8.34999 2.21725L8.00067 2.56956L7.65074 2.21784C6.8857 1.45101 5.91672 1.02452 4.92675 1.00179C3.93681 0.979662 2.92474 1.36129 2.07059 2.21725C2.0676 2.21964 2.06461 2.22263 2.06162 2.22562C1.17096 3.21797 0.891031 4.36467 1.03638 5.50884C1.18113 6.65312 1.73622 7.79856 2.4899 8.86632C3.99546 10.9994 6.2959 12.825 7.89838 13.6312L7.90077 13.6318L7.90257 13.6324C7.90855 13.6348 7.91453 13.6372 7.92051 13.639C7.93547 13.645 7.95042 13.6503 7.96657 13.6533C7.98811 13.6563 8.01084 13.6563 8.03297 13.6533C8.05869 13.6492 8.08321 13.6408 8.10594 13.6282C9.70843 12.8213 12.0066 10.9969 13.5109 8.86563C14.2646 7.79791 14.8191 6.65308 14.9638 5.50876C15.1086 4.36448 14.8292 3.21781 13.9386 2.22554C13.9362 2.22255 13.9332 2.21956 13.9302 2.21717C13.103 1.38811 12.1274 1.00299 11.1667 1Z" fill="black"/>
              <path d="M8.09935 3.07324C8.01502 3.11571 7.91333 3.09956 7.84634 3.03316L7.84753 3.03376L7.34209 2.52832C5.95444 1.1376 3.94525 0.965883 2.3858 2.52473C1.57888 3.4268 1.34021 4.41491 1.47181 5.45391C1.604 6.49533 2.12141 7.58458 2.84757 8.61401C4.26936 10.6293 6.48851 12.4046 8.00124 13.1918C9.514 12.4045 11.7331 10.6286 13.1549 8.61401C13.8811 7.58453 14.3985 6.49469 14.5307 5.4533C14.6623 4.41433 14.423 3.42613 13.6161 2.52411C12.8607 1.76924 11.9999 1.41931 11.1553 1.41871C10.2563 1.41752 9.37523 1.81112 8.65983 2.52772M11.1667 1C11.1356 1 11.1051 1 11.074 1.0006C10.084 1.02273 9.11501 1.45041 8.34999 2.21725L8.00067 2.56956L7.65074 2.21784C6.8857 1.45101 5.91672 1.02452 4.92675 1.00179C3.93681 0.979662 2.92474 1.36129 2.07059 2.21725C2.0676 2.21964 2.06461 2.22263 2.06162 2.22562C1.17096 3.21797 0.891031 4.36467 1.03638 5.50884C1.18113 6.65312 1.73622 7.79856 2.4899 8.86632C3.99546 10.9994 6.2959 12.825 7.89838 13.6312L7.90078 13.6318L7.90257 13.6324C7.90855 13.6348 7.91453 13.6372 7.92051 13.639C7.93547 13.645 7.95042 13.6503 7.96657 13.6533C7.98811 13.6563 8.01084 13.6563 8.03297 13.6533C8.05869 13.6492 8.08321 13.6408 8.10594 13.6282C9.70843 12.8213 12.0066 10.9969 13.5109 8.86563C14.2646 7.79791 14.8191 6.65308 14.9638 5.50876C15.1086 4.36448 14.8292 3.21781 13.9386 2.22554C13.9362 2.22255 13.9332 2.21956 13.9302 2.21717C13.103 1.38811 12.1274 1.00299 11.1667 1Z" stroke="black" stroke-width="0.3"/>
            </svg></span>
           </button>
           <div class="card-wrapper not-boost">
           <div class="grid-top card card--product">
              <div class="grid-imagebox card__inner">
                 <a href="{{du}}" class="product-link">
                 <div>
                    <div class="product-images media media--transparent media--adapt media--hover-effect">
                      <img alt="" class="swym-wishlist-image" src="{{iu}}">
                      <img alt="" class="second-image" src="">
                    </div>
                  </div>
                 </a>
              </div>
              <a href="#" class="add-to-cart-grid-button hide-element">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10.125 3.375H1.875C1.66789 3.375 1.5 3.54289 1.5 3.75V9.75C1.5 9.95711 1.66789 10.125 1.875 10.125H10.125C10.3321 10.125 10.5 9.95711 10.5 9.75V3.75C10.5 3.54289 10.3321 3.375 10.125 3.375Z" stroke="#666666" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.125 4.875V3.375C4.125 2.87772 4.32254 2.40081 4.67417 2.04917C5.02581 1.69754 5.50272 1.5 6 1.5C6.49728 1.5 6.97419 1.69754 7.32583 2.04917C7.67746 2.40081 7.875 2.87772 7.875 3.375V4.875" stroke="#666666" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </a>
              <div class="size-variant-list" data-handle="add-to-cart10325924053330" bis_skin_checked="1">
                <div class="size-variant-title" bis_skin_checked="1">Choose your size</div>
                <div class="grid-size-wrapper">&nbsp;</div>
              </div>
              
           </div>
           <div class="card-information" bis_skin_checked="1">
              <div class="card-information__wrapper" bis_skin_checked="1">
                  <div class="product-title-wc" bis_skin_checked="1">
                    <a href="{{du}}" class="full-unstyled-link">
                      <div class="caption-with-letter-spacing light" bis_skin_checked="1">{{bt}}</div>
                    </a>
                    <span class="card-information__text h5">
                      <a href="{{du}}">{{dt}}</a>
                    </span>
                  </div>
                  <div class="product-price-wc" bis_skin_checked="1">
                    <div class="price " bis_skin_checked="1">
                    <p class="grid-price">
                      <span class="swym-product-final-price original-price" data-wpd-product-handle="" data-wpd-variant-id="{{epi}}" 
                      data-wpd-variant-price="" data-wpd-variant-compare-at-price="" data-wpd-product-id="{{empi}}">{{cu}}{{pr}}</span>
                      <span class="compare-price hide-element">{{cu}}<span>&nbsp;</span></span>
                    </p>
                    </div>
                  </div>
              </div>
            </div>
           </div>
        </div>
     </div>
     </li>
   {{/products}}
</ul>`;
var variantModalMarkUp = `
  <ul>
    {{#product.options}}
      {{#values}}
        <li class="select-variant-{{name}}" id="user-options-{{name}}">
          <div class="li-list" >
            <a ref="">
              <span data-value="{{.}}" data-id="">{{.}}</span>
            </a>
          </div>
        </li>
      {{/values}}
    {{/product.options}}
  </ul>
  `;

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err){
    return variants;
  }
}

function popupclick(swat){
  if (swat.target.classList.contains('custom-btn')){
    const productItem = swat.target.closest('.product-item .snippet-product-grid');
    if(productItem){
      const currentID = productItem.getAttribute('data-product-id');
      const currentVID = productItem.getAttribute('data-variant-id');
      const currentDURL = productItem.getAttribute('data-url');
      
        window._swat.fetch(function (products) {
            document.body.classList.add("active-wishli-pro");
            products.forEach(function (p) {
                const productId = p.empi; 
                
                if (productId.toString() === currentID) { 
                    const params = {
                        du: p.du,
                        empi: parseInt(productId),
                        epi: parseInt(p.epi),
                    };
                    window._swat.getProductDetails(params, function (productJson1) {
                        document.querySelectorAll('.wpp-buy-popup').forEach((variantAdd) => {
                        variantAdd.setAttribute('data-pro-id',productJson1.id);
                      });
                      document.querySelector('.wpp-head h3 a').textContent = productJson1.title;
                      document.querySelector('.wpp-head h3 a').setAttribute('href',productJson1.url);
                      document.querySelector('.pdb-link a').setAttribute('href',productJson1.url);
                      document.querySelector('.grid-price-wrap .original-price').textContent = productItem.querySelector('.original-price').textContent;
                      if (productJson1.compare_at_price != null) {
                        document.querySelector('.grid-price-wrap .compare-price').textContent = productItem.querySelector('.compare-price').textContent;
                      }else{
                        document.querySelector('.grid-price-wrap .compare-price').textContent = '';
                      }
                      document.querySelector('.wpp-media .first-img-wp').setAttribute('src',productJson1.images[0]);
                      document.querySelector('.wpp-media .sec-img-wp').setAttribute('src',productJson1.images[1]);

                      document.querySelectorAll('.wpp-head h3 a').forEach(function(titleElement) {
                        let title = titleElement.textContent;
                        let firstPart = title.split('|')[0].trim();
                        titleElement.textContent = firstPart;
                    });

                     const container = document.querySelector('.wpp-meta');
                      const ul = document.createElement('ul');
                      ul.classList.add('wpp-meta-ul');
                      productJson1.variants.forEach(variant => {
                        const li = document.createElement('li');
                        const a = document.createElement('a');
                        li.setAttribute("data-variant", variant.id);
                        a.textContent = variant.option2;
                        li.appendChild(a);
                        ul.appendChild(li);
                       
                      });
                      container.appendChild(ul);


                      if (productJson1.available == false) {
                          document.querySelector('.wpp-add-to-cart button').textContent = "Sold out";
                      }else{
                        document.querySelector('.wpp-add-to-cart button').textContent = "Add to bag";
                      }
                       document.querySelector('.wpp-media-wrap .swym-delete-btn').setAttribute('data-variant-id',currentVID);
                      document.querySelector('.wpp-media-wrap .swym-delete-btn').setAttribute('data-product-id',currentID);
                      document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn').setAttribute('data-product-id',currentID);
                      document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn').setAttribute('data-variant-id',currentVID);
                      document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn').setAttribute('data-url',currentDURL);

                      var jsonvariantid = productJson1.variants;
                      console.log(jsonvariantid,'jsonvariantid----111---');
                      jsonvariantid.forEach(function (variant) {
                          const liElement = document.querySelector(`.wpp-meta-ul li[data-variant="${variant.id}"]`);
                          if (liElement && variant.available === false) {
                              liElement.classList.add("soldout_variant");
                          }
                      });
                      
                    });
                }
            });
          setTimeout(function () {
            document.querySelector(".wpp-meta-ul").addEventListener("click", (e) => {
              if (e.target.tagName === "LI" || e.target.closest("li")) {
                const clickedLi = e.target.closest("li");
                // console.log(clickedLi,"match li");
                document.querySelectorAll(".wpp-meta-ul li").forEach((li) => {
                  li.classList.remove("active");
                });
          
                clickedLi.classList.add("active");
                const paranode1 = clickedLi.closest(".wpp-buy-popup");
                const productId = paranode1.getAttribute("data-pro-id");
                const variantId = clickedLi.getAttribute("data-variant");
                const du = paranode1.getAttribute("data-url");
          
                if (clickedLi.classList.contains("soldout_variant")) {
                  const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
                  addToCartButton.textContent = "Sold out";
                  addToCartButton.disabled = true;
                  addToCartButton.classList.add("sold-out");
                } else {
                  const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
                  addToCartButton.textContent = "Add to bag";
                  addToCartButton.disabled = false;
                  addToCartButton.classList.remove("sold-out");
                }
              }
            });
          }, 1000);
        });
    } else {
        console.log('No product-item found for this button');
    }
  }
}

function addtocartpopup() {
  const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
  if (addToCartButton.classList.contains("sold-out")) {
    console.log("Cannot add sold-out product to cart.");
    return;
  }

  const productId = document.querySelector('.wpp-media-wrap .swym-delete-btn').getAttribute('data-product-id');
  const variantId = document.querySelector('.wpp-meta-ul li.active').getAttribute('data-variant');
  const productUrl = document.querySelector('.product-item .snippet-product-grid').getAttribute('data-url');

  const cartData = {
    id: variantId,
    quantity: 1
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add product to cart');
      }
      return response.json();
    })
    .then(data => {
      // console.log("Product added to cart:", data);
      addToCartButton.setAttribute("data-state-cart", "swym-added");
      load_cart();
      setTimeout(function () {
        document.querySelector("body").classList.add("open-drawer");
      }, 500);
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        document.body.classList.remove("active-wishli-pro");
        const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
        addToCartButton.textContent = "Add to bag";
        addToCartButton.disabled = false;
        
        const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
        createdUlElements.forEach(ul => ul.remove());
        
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

function swymRenderWishlist(swat) {
  swat.fetch(function (products) {
    document.querySelector(".wishlist-count").textContent = "(" + products.length + ")";
    document.querySelector(".wishlist-count").setAttribute('data-count',products.length);
    countWishlist();
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    var formattedWishlistedProducts = products.map(function (p, n) {
      console.log(p,'p----');
      completeProductJson = {};
      var productId = p.empi;
      var variantId = p.epi;
      var variantTitle = p.vi;
      var du = p.du;
      var params = {
        du: du,
        empi: parseInt(productId),
        epi: parseInt(variantId),
      };

      variantButtonAttributes = {};
      variantButtonAttributes = params;
      window._swat.getProductDetails(params, function (productJson) {
      completeProductJson = productJson;
       
        productJson.du = du;
        var variantMarkUpTemplate = SwymUtils.renderTemplateString(
          variantModalMarkUp,
          {
            product: productJson,
          }
        );
        document.querySelectorAll('.snippet-product-grid[data-product-id="' +productId +'"] .grid-size-wrapper').forEach((variantAdd) => {
          variantAdd.innerHTML = variantMarkUpTemplate;
        });
        if (n == products.length - 1) {
          attachModalEventListeners();
        }
        let price = productJson.price;
        let handle = productJson.handle;
        let compare_at_price = productJson.compare_at_price;
        document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-price',price);
        document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-product-handle',handle);
        
        if (compare_at_price != null) {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.remove("d-none");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price span').textContent = compare_at_price / 100;
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-compare-at-price',compare_at_price);
          if (compare_at_price > price) {
            document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-meta-inr').classList.add("pro-sale");
            
            let saving = ((compare_at_price - price) * 100) / compare_at_price;
            function customRound(value) {
              let remainder = value % 5;
              if (remainder <= 2) {
                return value - remainder;
              } else {
                return value + (5 - remainder);
              }
            }
          }
        } else {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').style.color = "#464545";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.add("d-none");
        }
      
        if (productJson.images[1]) {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .second-image').setAttribute("src", productJson.images[1]);
        } else {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .swym-wishlist-image').style.opacity = "1";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .second-image').classList.add("d-none");
        }
        if (productJson.available == false) {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] #swym-custom-add-toCartBtn').classList.add("grid-soldOut");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .p-add-cart-btn').textContent = "Sold out";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-price').classList.add("soldout_pro");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-meta-inr').classList.add("sold_plus_sale");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .pro-sold').style.display = "block";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .pro-sold.d-lg-none').style.display = "block";
        }
        
        var jsonvariantid = productJson.variants;
        jsonvariantid.forEach(function(i, value) {
          document.querySelector('.snippet-product-grid[data-variant-id="' + variantId + '"] .grid-size-wrapper').setAttribute('data-count',jsonvariantid.length);
          const element = document.querySelector('.snippet-product-grid[data-variant-id="' + variantId + '"] .grid-size-wrapper li span[data-value="' + i.option1 + '"]');
          if(element){
            if(window.outerWidth > 991){
              element.closest('a').setAttribute('href',productJson.du+'?variant='+i.id);
            }
            element.closest('.card-wrapper').querySelector('.add-to-cart-grid-button').setAttribute('data-id',i.id);
            element.setAttribute('data-id',i.id);
            element.closest('.card-wrapper').querySelector('.add-to-cart-grid-button').setAttribute('data-handle', 'add-to-cart' + productJson.id);
            if(jsonvariantid.length == 1){
              element.closest('.card-wrapper').querySelector('.add-to-cart-grid-button').classList.add('singlevariant');
            }else{
              element.closest('.card-wrapper').querySelector('.add-to-cart-grid-button').classList.add('multiple-variant-click');
            }
            if (i.available == false){
              const nextLabel = element.nextElementSibling;
              element.closest('li').classList.add("soldout-var")
            }
            var allvarName = i.title;
            if (i.title == variantTitle){
              element.checked = !0;
              const nextLabel = element.nextElementSibling;
              element.closest('li').classList.add("active")
            }
          }
        })

        let images = document.querySelectorAll(".product-images img:not(.second-image)");
        images.forEach((img) => {
          if(img.complete){
            img.classList.add("loaded");
          }else{
            img.addEventListener("load", () => img.classList.add("loaded"));
          }
        });
        addEvent();
      });
      countWishlist();
      p = SwymUtils.formatProductPrice(p);
  
      p.pr = p.pr.split('.')[0];
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      if (p.vi) {
        p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
        if (p.vi.includes("/")) {
          p.vi = p.vi.split("/")[0];
        } else if (p.vi.includes(" ")) {
          p.vi = p.vi.split(" ")[0];
        }
      }
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      document.querySelectorAll(".swym-wishlist-image").forEach((firstImg) => {
        let srcVal = firstImg.getAttribute("src");
        if (srcVal.includes("_620x620")) {
          srcVal = srcVal.replaceAll("_620x620", "");
        } else if (srcVal.includes("620")) {
          srcVal = srcVal.replaceAll("620", "");
        }
        firstImg.setAttribute("src", srcVal);
      });
              
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}
function addEvent(){
  console.log('inn');
  $('.multiple-variant-click').on("click", function(e) {
   console.log("loadmore-click-----------");
    e.preventDefault();
    e.stopImmediatePropagation();
    var $parent = $(this).parents('.grid__item');
    var $overlay = $('.overlay-box');
    var $body = $('body');
    var childHandle = $(this).data('handle');
    var $gridItem = $(this).closest('.grid__item');
    $(this).siblings('.size-variant-list').slideDown();
    $(this).parents('.grid__item').siblings('.grid__item').find('.size-variant-list').slideUp();
    $parent.find('.size-variant-list').each(function() {
      var $content = $(this);
      var contentHandle = $content.data('handle');
    $body.addClass('active-dot-body');
      if (childHandle === contentHandle) {
        if ($gridItem.hasClass('active-dot')) {
          $gridItem.removeClass('active-dot');
          $body.removeClass('active-dot-body');
        } else {
          $parent.find(".grid__item").each(function() {
            $(this).removeClass('active-dot');
            $body.removeClass('active-dot-body');
          });
          $gridItem.addClass('active-dot');
          $body.addClass('active-dot-body');

          
        //   $('.size-variant-list ul a').on('click', function(e) {
        //     if ($(this).attr('href') === '#') {
        //         e.preventDefault();
        //         var varid = $(this).find('span').data('id');
        //         $.ajax({
        //             type: 'POST',
        //             url: '/cart/add.js',
        //             dataType: 'json',
        //             data: { id: varid, quantity: 1 },
        //             success: function(response) {
        //               $('.overlay-box').click();
        //                 ajaxCart.load();
        //                 $('body').addClass('CartOpen');
        //             }
        //         });
        //       }
        // })
    
        }
      }
    });
    $overlay.on('click', function() {
      $('.grid__item').removeClass('active-dot');
      $body.removeClass('active-dot-body');
      $('.size-variant-list').slideUp();
    });
  });
   $(document).on('click','.singlevariant', function(e) {
    e.preventDefault();
      
    let getvariant = $(this).data('id');
    console.log("single========",getvariant);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { id: getvariant, quantity: 1 },
      success: function(data) {
        ajaxCart.load();
        $('body').addClass('CartOpen');
      },
      error:function(xhr, ajaxOptions, thrownError) {
        console.log("error");
      }
    });
  });
  $('#wishlist-items-container .size-variant-list ul a').on('click', function(e) {
    e.preventDefault();
    var varid = $(this).find('span').data('id');
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { id: varid, quantity: 1 },
        success: function(response) {
          $('.overlay-box').click();
            ajaxCart.load();
            $('body').addClass('CartOpen');
        }
    });
  })
}
function attachClickListeners() {
  
  document.querySelectorAll('.swym-wishlist-grid').forEach(function(parent) {
   parent.querySelectorAll('.cus-add-btn').forEach(function (child) {
    child.addEventListener("click", function (event) {
      parent.querySelectorAll('.grid-btm').forEach(function (item) {
        item.classList.remove('active-add');
      });
      const packet = child.closest(".grid-btm");
      if (packet) {
        packet.classList.add('active-add');
      }
  
      const productItem = event.target.closest('.product-item .snippet-product-grid');
      if (productItem) {
        const currentID = productItem.getAttribute('data-product-id');
        window._swat.fetch(function (products) {
          const matchedProduct = products.find(p => p.empi.toString() === currentID);
  
          if (matchedProduct) {
            const params = {
              du: matchedProduct.du,
              empi: parseInt(matchedProduct.empi, 10),
              epi: parseInt(matchedProduct.epi, 10),
            };
  
            window._swat.getProductDetails(params, function (productJson1) {
              if (productJson1.id.toString() === currentID) {
                const jsonVariantId = productJson1.variants;
                if (jsonVariantId && jsonVariantId.length > 0) {
                  jsonVariantId.forEach(function (variant) {
                    if (variant.option2) {
                      const sizeElements = productItem.querySelectorAll('#user-options-Size .sywm-radio');
                      sizeElements.forEach((ele) => {
                        
                        const sizeValue = ele.getAttribute('data-value');
                        if (variant.option2 === sizeValue) {
                          ele.setAttribute('var-id',variant.id);
                          if (!variant.available) {
                            ele.classList.add("soldout_variant");
                          } else {
                            ele.classList.remove("soldout_variant");
                          }
                        }
                      });
                    }
                    attachModalEventListeners();
                  });
                }
              } else {
                console.warn('No matching product found for ID:', currentID);
              }
            });
          }
        });
      }
    });
   });
  });
  document.querySelectorAll('.grid-title a').forEach(function(titleElement) {
      let title = titleElement.textContent;
      let firstPart = title.split('|')[0].trim();
      titleElement.textContent = firstPart;
  });
    
  document.querySelectorAll('.swym-wishlist-grid').forEach(function (parent) {
    parent.querySelectorAll('.custom-btn').forEach(function (child) {
      child.addEventListener("click", popupclick);
    });
  });

  document.querySelector('.wpp-add-to-cart').addEventListener("click",addtocartpopup);
  
  document.querySelector('.mpp-close').addEventListener("click", function(e) {
    document.body.classList.remove("active-wishli-pro");
    const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
    addToCartButton.textContent = "Add to bag";
    addToCartButton.disabled = false;
    const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
    createdUlElements.forEach(ul => ul.remove());  
  });

  var addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  // for (var i = 0; i < addToCartButtons.length; i++) {
  //   addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  // }
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
}

function countWishlist() {
  window._swat.fetch(function (r) {
    const count = r.length;
    const wishlistCount = document.querySelector(".wishlist-count");
    const emptyWishlist = document.querySelector(".empty-wishlist");

    if (wishlistCount) {
      wishlistCount.textContent = "(" + count + ")";
      wishlistCount.setAttribute("data-count", count);
    }

    if (emptyWishlist) {
      if (count === 0) {
        emptyWishlist.style.display = "block";
      } else {
        emptyWishlist.style.display = "none";
      }
    }
  });
}

function attachModalEventListeners() {
  document
    .querySelectorAll(".product-item .sywm-radio")
    .forEach((radioWrapper) => {
      radioWrapper.addEventListener("change", function (e) {

        const parentGrid = e.target.closest(".snippet-product-grid");
        if (!parentGrid) {
          console.warn("Parent grid not found for .sywm-radio");
          return;
        }

        const radioInput = radioWrapper.querySelector("input[type='radio']");
        if (!radioInput) {
          console.warn("Radio input not found inside .sywm-radio");
          return;
        }

        parentGrid.querySelectorAll(".sywm-radio.active").forEach((activeRadio) => activeRadio.classList.remove("active"));

        if (radioInput.checked) {
          radioWrapper.classList.add("active");
        } else {
          console.warn("Radio is checked but active class was not applied.");
        }

        const isSoldOut = radioWrapper.classList.contains("soldout_variant");
        const addToCartBtn = parentGrid.querySelector("#swym-custom-add-toCartBtn");

        if (isSoldOut) {
          addToCartBtn.classList.add("grid-soldOut");
          addToCartBtn.textContent = "Sold Out";
          addToCartBtn.setAttribute("disabled", "true");
          console.log("This variant is sold out.");
        } else {
          addToCartBtn.classList.remove("grid-soldOut");
          addToCartBtn.textContent = "Add to bag";
          addToCartBtn.removeAttribute("disabled");

          const productId = parentGrid.getAttribute("data-product-id");
          const variantId = radioWrapper.getAttribute("data-variant-id");
          const du = parentGrid.getAttribute("data-url");

          const params = {
            du: du,
            empi: parseInt(productId),
            epi: parseInt(variantId),
          };

          window._swat.getProductDetails(params, function (productJson) {
            addToCartBtn.onclick = function () {
              if (!isSoldOut) {
                const activeRadioWrapper = parentGrid.querySelector(".sywm-radio.active");
                const variantId = activeRadioWrapper.getAttribute("var-id");
                const cartData = {
                  id: variantId,
                  quantity: 1,
                };

                fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(cartData),
                })
                  .then((response) => {
                    if (!response.ok) {
                      throw new Error("Failed to add product to cart");
                    }
                    return response.json();
                  })
                  .then((data) => {
                    load_cart();
                    setTimeout(function () {
                      document.querySelector("body").classList.add("open-drawer");
                    }, 500);
                  })
                  .catch((error) => {
                    console.error("Error:", error);
                  });
              } else {
                console.log("Cannot Add to bag, the variant is sold out.");
              }
            };
          });
        }
      });
    });
}
attachModalEventListeners();

function getSelectTagValues(selector) {
  var userSelection = {};
  if (typeof selector !== "undefined") {
    var optionValue = selector.getAttribute("data-value");
    if (optionValue != undefined) {
      var key = "option" + (0 + 2);
      var selectedValueObj = _defineProperty({}, key, optionValue.toString());
      if (SwymUtils) {
        SwymUtils.extendDefaults(userSelection, selectedValueObj);
      }
    }
    return userSelection;
  } else {
    console.log("Invalid Option Selector");
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function findVariant(userSelectedOption, completeProductJson1) {
    var keys = Object.keys(userSelectedOption).filter(function (key) {
      return (
        userSelectedOption[key] !== null && userSelectedOption[key] !== undefined
      );
    });
  
  var match = completeProductJson1.variants.find(function (variant) {
    return keys.every(function (key, value) {
      return (
        variant[key] === userSelectedOption[key] &&
        variant[value] === userSelectedOption[value]
      );
    });
  });
  
  return match;
}
function removeProductFromWishlist(old_product_variant, callback) {
  window._swat.removeFromWishList(old_product_variant, function (r) {
    callback(r);
  });
}
function addProductToWishlist(new_product_variant) {
  window._swat.addToWishList(new_product_variant, function (r) {
    renderWishlistUI();
  });
}
function renderWishlistUI() {
  _swat.fetch(function (products) {
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for (let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails(
        {
          du: WishlistedProducts[i].du,
          epi: WishlistedProducts[i].epi,
          empi: WishlistedProducts[i].empi,
        },
        function (fullProductDetails) {
          for (let j = 0; j < fullProductDetails.variants.length; j++) {
            var sameid = fullProductDetails.variants[j].id;
            
            if (fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
              WishlistedProducts[i].available = fullProductDetails.variants[j].available;
            }
          }
        }
        
      );
    }

    setTimeout(function (e) {
      var h3height = 0;
    }, 2000);
    currentUserWishlist = [];
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    currentUserWishlist = products;
    var completeProductJson = {};
    var formattedWishlistedProducts = WishlistedProducts.map(function (p, n) {
      var productId = p.empi;
      var variantId = p.epi;
      var variantTitle = p.vi;
      var du = p.du;
      var params = {
        du: du,
        empi: parseInt(productId),
        epi: parseInt(variantId),
      };
      variantButtonAttributes = {};
      variantButtonAttributes = params;
      window._swat.getProductDetails(params, function (productJson) {
        completeProductJson = productJson;
        productJson.du = du;
        var variantMarkUpTemplate = SwymUtils.renderTemplateString(
          variantModalMarkUp,
          {
            product: productJson,
          }
        );
        document.querySelectorAll('.snippet-product-grid[data-product-id="' +productId +'"] .grid-size-wrapper').forEach((variantAdd) => {
          variantAdd.innerHTML = variantMarkUpTemplate;
        });
        if (n == products.length - 1) {
          attachModalEventListeners();
        }
        if (productJson.available == false) {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] #swym-custom-add-toCartBtn').classList.add("grid-soldOut");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .p-add-cart-btn').textContent = "Sold out";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-badge span').textContent = "Sold out";
        }
        
      var jsonvariantid = productJson.variants;
      console.log(jsonvariantid,'jsonvariantid-------');
      jsonvariantid.forEach(function(i, value) {
          const element = document.querySelector('.snippet-product-grid[data-variant-id="' + variantId + '"] .sywm-radio[data-value="' + i.option1 + '"]');
          console.log(jsonvariantid.length,'i------',i);
          if (i.available == false) {
              const nextLabel = element;
              element.classList.add("soldout_variant")
          }
          var allvarName = i.title;
          if (i.option1 == variantTitle) {
              element.checked = !0;
              const nextLabel = element;
              element.classList.add("active")
          }
      })
        
      });
      
      countWishlist();
      p = SwymUtils.formatProductPrice(p);
      p.pr = p.pr.split('.')[0];
      p.variantinfo = p.variants ? getVariantInfo(p.variants) : "";
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      if (p.vi) {
        if (p.vi.includes("/")) {
          p.vi = p.vi.split("/")[0];
        } else if (p.vi.includes(" ")) {
          p.vi = p.vi.split(" ")[0];
        }
      }
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: WishlistedProducts,
    });
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    attachClickListeners();
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist);